import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/es";
import iconTrash from "../assets/pepper-icons/rightbar/iconTrash.svg";
//import pepperIcon3 from "../assets/pepper-icons/sidebar/Pepper3IconSinfondo.svg";
import pepperIcon3 from "../assets/svg/Pepper/Logo_Pepper_2022.svg";
import { useSelector, useDispatch } from "react-redux";
import { BuyPepperModal } from "src/utils/suscribePepperModal";
import { PaymentSuccessful } from "src/graphql/company";
import {
  Button,
  Dropdown,
  Icon,
  TransitionablePortal,
  Segment,
  Popup,
  Header as SemanticHeader,
  Image,
} from "semantic-ui-react";
import { SubcribeWS } from "../graphql/botsWs";
import { SortCompany } from "../utils/companyList";
import { rutWithNumbers, formatRut, rutWithDash } from "../utils/formatter";
import {
  importMonedas,
  setCurrency,
  setSidebarResponsive,
} from "../redux/actions/ui";
import {
  importNotifications,
  importUpdateNotifications,
  updateNotifications,
} from "../redux/actions/notifications";
import {
  CHeader,
  CToggler,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { ConciliationRatio } from "./conciliationRatio";
import {
  importSelectedCompany,
  importLoadingState,
} from "../redux/actions/companyList";
import { importAlertState } from "../redux/actions/alert";
import { setUpdateDocuments } from "../redux/actions/documentostributarios";
import {
  importUpdateNominaInProcessNeeded,
  importUpdateNominaProccesedNeeded,
  importUpdateProvidersData,
} from "../redux/actions/proveedores";
import { importUpdateTransactions } from "../redux/actions/conciliacion";
import {
  importUpdateBalanceNeeded,
  importUpdateCashFlow,
} from "../redux/actions/flujocaja";
import { posiblePasswords } from "src/utils/passwordAccepted";

import "./Header.scss";
import { Plans } from "src/utils/plans";
import { importUpdateDashboardNeeded } from "src/redux/actions/dashboard";
import { importUpdatePasswordNeeded } from "src/redux/actions/conexiones";
import { importDataConexiones } from "src/redux/actions/conexiones";
import { GetPasswordsByCompany } from "src/graphql/conexiones";
import bankLogo from "src/assets/svg/svg_banks";
import platformLogo from "src/assets/svg/svg_platforms";
import UserIcon from "src/assets/icons/Avatar_standard.svg";
import { useContext } from "react";
import { CompanyContext } from "src/context";
import { SuscribeButton } from "src/utils/piriodForm2024";
import {
  AppNotificationsSuscription,
  GetNotifications,
  MarkNotificationAsReaded,
} from "src/graphql/appNotifications";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { importOpenSidebar } from "src/redux/actions/openSidebar";
import { GlobalSearch } from "./GlobalSearch/GlobalSearch";

const Header = ({ location }) => {
  const dispatch = useDispatch();
  const { dataConexiones, allConnections } = useSelector(
    (state) => state.conexiones
  );
  const [openNotification, setOpenNotification] = useState(false);
  const [newSelectedCompany, setNewSelectedCompany] = useState();

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const { email, name, surname, uid, ...rest } = useSelector(
    (state) => state.auth
  );
  const { updateCompanyNeeded } = useSelector((state) => state.companyList);
  const { sidebarShow, dropdownCurrency, currency } = useSelector(
    (state) => state.ui
  );
  const { notification } = useSelector((state) => state.notifications);

  const { companyList, selectedCompany } = useContext(CompanyContext);
  const currentUser = useSelector((state) => state.auth);;

  const res = SubcribeWS(selectedCompany.id);
  ;
  const companyId = selectedCompany.id;

  const resNotifications = AppNotificationsSuscription(currentUser.uid);
  const { data: getNotificationsData, reexecuteQuery: getNotificationsReexecuteQuery } = GetNotifications(uid, companyId);
  const [unreadedNotificationsQuantity, setUnreadedNotificationsQuantity] = useState(0);

  const [notifications, setNotifications] = useState([]);

  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const {
    executeMutation: paymentSuccessful,
    fetching: paymentSuccessfulLoading,
  } = PaymentSuccessful();
  const { data, fetching, reexecuteQuery } = GetPasswordsByCompany(companyId);

  let title = "";
  if (location) {
    if (location.pathname.includes("flujo")) title = "Flujo de caja";
    else if (location.pathname.includes("documentos_tributarios"))
      title = "Documentos tributarios";
    else if (location.pathname.includes("creditos")) title = "Préstamos";
    else if (location.pathname.includes("proveedores"))
      title = "Pago a proveedores";
    else if (location.pathname.includes("agenda"))
      title = "Clientes y Proveedores";
    else if (location.pathname.includes("conexiones")) title = "Conexiones";
    else if (location.pathname.includes("usuarios")) title = "Usuarios";
    else if (location.pathname.includes("reportes")) title = "Reportes";
    else if (location.pathname.includes("reportes_dj")) title = "Reportes DJ";
    else if (location.pathname.includes("conciliacion"))
      title = "Conciliación Bancaria";
  }

  useEffect(() => {
    if (!fetching) {
      dispatch(importDataConexiones(data?.allPasswordsByCompanyId));
    }
  }, [dispatch, data]);


  useEffect(() => {
    getNotificationsReexecuteQuery({
      requestPolicy: 'cache-and-network',
      variables: { uid, companyId },
    });
  }, [companyId]);


  useEffect(() => {
    if (!resNotifications?.data) return;

    setNotifications(resNotifications?.data);
  }, [resNotifications]);

  useEffect(() => {
    reexecuteQuery({ requestPolicy: "network-only" });
  }, [companyId]);

  useEffect(() => {
    dispatch(importMonedas());
  }, [dispatch]);
  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch(setSidebarResponsive(val));
  };

  useEffect(() => {
    if (openNotification) {
      setOpenNotification(false);
    }
  }, [location]);

  moment.locale("es");

  useEffect(() => {
    if (!res.fetching && res.data) {
      dispatch(importNotifications(res.data));

      const [botData] = res.data;

      if (botData) {
        dispatch(
          importAlertState({
            concept: botData.title,
            content: botData.mssg,
            state: botData.ok ? "success" : "error",
            duration: 8,
          })
        );
        dispatch(setUpdateDocuments({ value: true }));
        dispatch(importUpdateProvidersData(true));
        dispatch(importUpdateCashFlow(true));
        dispatch(importUpdateTransactions(true));
        dispatch(importUpdateDashboardNeeded({ value: true }));
        dispatch(importUpdateBalanceNeeded({ value: true }));
        dispatch(importUpdatePasswordNeeded({ value: true }));
        dispatch(importUpdateNominaProccesedNeeded({ value: true }));
        dispatch(importUpdateNominaInProcessNeeded({ value: true }));
        dispatch(importUpdateProvidersData(true));
      }
    }
  }, [res.data]);

  notification?.sort((a, b) => {
    if (a.ago > b.ago) {
      return -1;
    } else if (a.ago < b.ago) {
      return 1;
    } else {
      return 0;
    }
  });

  useEffect(() => {
    if (newSelectedCompany) {
      dispatch(
        importOpenSidebar({
          show: false,
        })
      );
      dispatch(importSelectedCompany(newSelectedCompany));
      dispatch(importLoadingState({ load: true }));
      getNotificationsReexecuteQuery({ requestPolicy: 'cache-and-network' })
      clearUrlParams();
    }
  }, [newSelectedCompany]);

  const clearUrlParams = () => {
    let type = searchParams.get("type");
    history.push(`?type=${type}&page=1&offset=20`);
  };

  const pendingNotification =
    notification && notification?.some((value) => value?.visited === false);


  useEffect(() => {
    if (!notifications) return;

    let unreadedNotifications = 0;
    notifications?.forEach((notification) => {
      const recipients = notification?.recipients || [];

      recipients.forEach((recipient) => {
        if (recipient?.isRead === false && recipient?.user === uid) {
          unreadedNotifications += 1;
        }
      })
    });

    setUnreadedNotificationsQuantity(unreadedNotifications);
  }, [notifications]);

  const notPendingNotification = () => {
    const watchedNotification = notification?.map((value, index) => {
      return {
        title: value?.title,
        description: value?.description,
        ejecucionCorrecta: value?.ejecucionCorrecta,
        ago: value?.ago,
        visited: true,
        ok: value?.ok,
      };
    });
    dispatch(importUpdateNotifications(watchedNotification));
  };

  useEffect(() => {
    const List =
      companyList?.length > 0
        ? companyList?.map((element) => {
          const showBlock = element?.plan
            ? element?.plan.includes(Plans.blocked)
            : false;
          //const isAdmin = USER.roles.includes('ADMIN')

          return {
            key: element?.id,
            // disabled: showBlock
            //   ? isAdmin ? false : true
            //   : false,
            value: {
              id: element?.id,
              name: element?.name,
              alias: element?.alias,
              plan: element?.plan,
              trialExpirationDate: element?.trialExpirationDate,
              rut: element?.rut,
              users: element?.users,
              suscriptionId: element?.suscriptionId,
            },
            text: showBlock
              ? (element?.alias || element?.name) + " (Bloqueado)"
              : element?.alias || element?.name,
            content: (
              <SemanticHeader
                className="truncateText"
                as={"h6"}
                content={element?.name || ""}
                subheader={`${formatRut(element?.rut)} ${element?.alias || ""
                  }`}
              />
            ),
          };
        })
        : [];

    setOptions(List);
  }, [companyList, updateCompanyNeeded?.value]);

  const customSearch = (options, query) => {
    return options.filter((option) => {
      if (option?.value?.alias?.toUpperCase()?.includes(query?.toUpperCase()))
        return option;
      if (option?.value?.rut?.toUpperCase()?.includes(query?.toUpperCase()))
        return option;
      if (
        formatRut(option?.value?.rut?.toUpperCase())?.includes(
          query?.toUpperCase()
        )
      )
        return option;
      if (
        rutWithNumbers(option?.value?.rut?.toUpperCase())?.includes(
          query?.toUpperCase()
        )
      )
        return option;
      if (option?.value?.name?.toUpperCase()?.includes(query?.toUpperCase()))
        return option;
    });
  };

  const DaysLeft = selectedCompany?.trialExpirationDate
    ? moment(selectedCompany?.trialExpirationDate).diff(moment(), "days", false)
    : 99;

  const daysLeftMessage =
    selectedCompany &&
      selectedCompany.plan &&
      selectedCompany.plan.includes(Plans.blocked)
      ? ""
      : DaysLeft <= 30 && DaysLeft > 0
        ? DaysLeft == 1
          ? `¡Te queda ${DaysLeft} día de prueba!`
          : `¡Te quedan ${DaysLeft} días de prueba!`
        : "¡No te quedan días de prueba!";

  const isSCFOClient =
    selectedCompany &&
    selectedCompany.plan &&
    (selectedCompany.plan.includes(Plans.smartcfo) ||
      selectedCompany.plan.includes(Plans.smartcfopro) ||
      selectedCompany.plan.includes(Plans.smartcfofull));

  const hasReconcileModule = [
    Plans.trial,
    Plans.pepper,
    Plans.smartcfofull,
    Plans.plan_base,
  ].some((plan) => selectedCompany?.plan?.includes(plan));

  const errorFounded =
    allConnections && Array.isArray(allConnections)
      ? allConnections.some((botLog) => {
        return (
          botLog?.isActive &&
          posiblePasswords[botLog.templateId] &&
          (botLog?.status == false ||
            ![
              "Ejecutado de forma correcta",
              "Ejecutado de forma correcta.",
              "Documentos actualizados correctamente",
              "Documentos actualizados correctamente.",
              "Documentos obtenidos exitosamente.",
              "Glosas obtenidas exitosamente.",
            ].includes(botLog?.botlogSummary[0]?.mssg))
        );
      })
      : false;
  const hasActiveConnections =
    allConnections && Array.isArray(allConnections)
      ? allConnections.some((conn) => conn?.isActive)
      : false;

  const customer = {
    name: selectedCompany?.name || "",
    tax_id: rutWithDash(selectedCompany?.rut || ""),
    email: email || "",
  };

  const metadata = {
    userID: uid || "",
    date: moment().toString(),
    companyId: selectedCompany?.id || "",
  };

  const getNotificationIsRead = (notification) => {
    if (!notification) return;

    const recipients = notification?.recipients;

    const curretRecipient = recipients.find(
      (recipient) => recipient.user === uid
    );

    if (!curretRecipient) return false;

    return curretRecipient?.isRead;
  };

  return (
    <CHeader withSubheader className="headerShadow" style={{ zIndex: "1032" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={pepperIcon3}
          alt="pepperIcon"
          style={{
            width: "40px",
            height: "40px",
          }}
        />
      </div>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CHeaderNav className="mr-auto">
        <CHeaderNavItem className="px-3">
          <Dropdown
            selectOnBlur={false}
            options={options}
            selection
            fluid
            search={customSearch}
            className="companyListDropdownItems notranslate"
            placeholder={selectedCompany?.alias || selectedCompany?.name}
            style={{ width: "320px" }}
            // defaultValue={selectedCompany?.id}
            value={selectedCompany?.id}
            onChange={(e, data) => setNewSelectedCompany(data?.value)}
            noResultsMessage="La empresa no existe."
            openOnFocus={false}
          />
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3">
          <CHeaderNavLink
            to="/dashboard"
            style={{
              color: "white",
              fontFamily: "Helvetica",
              fontSize: "26pt",
              fontWeight: "bold",
            }}
          ></CHeaderNavLink>
          {
            hasReconcileModule && companyId != '633c7e0c92acad001b87a074' && //DESHABILITADO PARA EMPRESA COBRANZA ONLINE (PETICION DE SMART)
            <ConciliationRatio />

          }
        </CHeaderNavItem>
      </CHeaderNav>
      {(selectedCompany?.plan &&

        (selectedCompany.plan || []).includes(Plans.trial) &&

        DaysLeft <= 30 &&

        !isSCFOClient) ||
        (selectedCompany &&
          selectedCompany.plan &&
          selectedCompany.plan.includes("blocked")) ? (
        <>
          <CHeaderNav className="px-3">
            <span className="headerDaysLeft">{daysLeftMessage}</span>
          </CHeaderNav>
          <CHeaderNav className="px-3">
            <SuscribeButton customer={customer} metadata={metadata} />
          </CHeaderNav>
        </>
      ) : (
        <CHeaderNav className="mr-auto">
          <CHeaderNavItem className="px-3"></CHeaderNavItem>
        </CHeaderNav>
      )}

      <CHeaderNav>
        <CHeaderNavItem>
          <GlobalSearch />
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav className="">
        <CHeaderNavItem className="px-3 h-100 d-flex align-items-center">
          <Dropdown
            selectOnBlur={false}
            className="noCaret"
            text={
              <div className="d-flex align-items-center">
                <Icon className="m-1" name="usb" size="large" />
                {errorFounded && <Icon name="circle" color="red" size="tiny" />}
              </div>
            }
          >
            <Dropdown.Menu
              style={{
                marginLeft: "-150px",
                width: "200px",
                marginTop: "16px",
              }}
            >
              {!fetching &&
                allConnections &&
                allConnections.length > 0 &&
                allConnections.map((conexion, index) => {
                  const botLogStatus =
                    conexion?.botlogSummary?.length > 0
                      ? conexion?.botlogSummary[0]?.status
                      : false;

                  if (posiblePasswords[conexion.templateId])
                    return (
                      <>
                        {conexion?.isActive && (
                          <Dropdown.Item
                            key={index}
                            style={{ width: "250px" }}
                            className="dont-drop-hover"
                          >
                            <img
                              alt={conexion?.templateId}
                              src={
                                bankLogo(conexion?.templateId) ||
                                platformLogo(conexion?.templateId)
                              }
                              style={{ height: "52px", width: "40px" }}
                            />
                            <span className="conn-name truncateText">
                              {conexion?.name}
                            </span>
                            <Popup
                              inverted
                              position="bottom center"
                              content={
                                !botLogStatus
                                  ? "Conexión presenta problemas"
                                  : "Conexión correcta"
                              }
                              trigger={
                                <Icon
                                  className="mr-3 ml-3 position-absolute right-0"
                                  style={{ cursor: "pointer" }}
                                  name="circle"
                                  color={
                                    !botLogStatus
                                      ? "red"
                                      : "green"
                                  }
                                  size="small"
                                />
                              }
                            />
                          </Dropdown.Item>
                        )}
                      </>
                    );

                  return "";
                })}

              {hasActiveConnections && <Dropdown.Divider />}
              <Dropdown.Item
                href="/conexiones"
                style={{ textDecoration: "none" }}
              >
                Revisar conexiones <Icon name="angle right" />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav className="">
        <CHeaderNavItem className="">
          <CDropdown>
            <CDropdownToggle
              caret
              color="info"
              style={{
                backgroundColor: "transparent",
                border: "none",
                display: "none",
              }}
            >
              {dropdownCurrency}
            </CDropdownToggle>
            <CDropdownMenu style={{ backgroundColor: "#8875F2" }}>
              <CDropdownItem
                style={{ color: "white" }}
                onClick={(e) => dispatch(setCurrency(e.target.innerText))}
              >
                {currency.dolar}
              </CDropdownItem>
              <CDropdownItem
                style={{ color: "white" }}
                onClick={(e) => dispatch(setCurrency(e.target.innerText))}
              >
                {currency.uf}
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="mr-4"
          >
            <TransitionablePortal
              open={open}
              onOpen={() => {
                setOpen(true);
                // notPendingNotification();
              }}
              onClose={() => setOpen(false)}
              trigger={
                <Button
                  style={{
                    backgroundColor: "transparent",
                    padding: "0",
                    margin: "0",
                  }}
                  onClick={() => setOpen(true)}
                >
                  {open ? (
                    <Icon name="large bell outline blue" />
                  ) : unreadedNotificationsQuantity > 0 ? (
                    <>
                      {unreadedNotificationsQuantity}
                      <Icon name="large bell outline blue" />
                    </>
                  ) : (
                    <Icon
                      name="large bell outline"
                      className="notificationBell"
                    />
                  )}
                </Button>
              }
            >
              <Segment
                style={{
                  position: "fixed",
                  top: "40px",
                  marginLeft: "69%",
                  zIndex: 1000,
                  maxHeight: "80vh",
                  overflow: "auto",
                  minWidth: "30vw",
                }}
              >
                {notifications?.length > 0 ? (
                  notifications?.map((value, index) => {
                    return (
                      <Notification
                        notificationId={value?.id}
                        key={index}
                        index={index}
                        title={value?.title}
                        description={value?.description}
                        referenceType={value?.referenceType}
                        comment={value?.comment}
                        redirectUrl={value?.redirectUrl}
                        ago={value?.ago}
                        ok={value?.ok}
                        data={value}
                        isRead={getNotificationIsRead(value?.notification)}
                        notification={value?.notification}
                        setOpen={setOpen}
                        uid={uid}
                        company={value.company}
                        currentCompany={companyId}
                        setNewSelectedCompany={setNewSelectedCompany}
                        clearUrlParams={clearUrlParams}
                      />
                    );
                  })
                ) : (
                  <div className="mainNotificationContainer">
                    <span className="mainNotificationContainer__title">
                      No cuentas con notificaciones nuevas
                    </span>
                  </div>
                )}
              </Segment>
            </TransitionablePortal>
          </div>
          {/* <CHeaderNavLink to="/dashboard" style={{color:"white", fontFamily: "Helvetica", fontSize: "14pt", "fontWeight": "regular"}}>Dolar: $766,41 / $776,41</CHeaderNavLink> */}
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav className="">
        <CHeaderNavItem className="px-3">
          <div className="header-100-percent">
            <Dropdown
              selectOnBlur={false}
              className="header-dropdown-avatar header-100-percent"
              text={
                <div className="d-flex align-items-center header-100-percent">
                  <span className="mr-2 header-100-percent d-flex align-items-center">
                    {name}
                  </span>
                  <div className="header-100-percent d-flex align-items-center">
                    <Image
                      src={UserIcon}
                      avatar
                      className="custom-avatar-header"
                    />
                  </div>
                </div>
              }
            >
              <Dropdown.Menu className="custom-dropdown-options-header">
                <Dropdown.Item
                  disabled
                  className="custom-pepper-user-information"
                >
                  {/* <div className="w-100 d-flex justify-content-end custom-pepper-user-information__rol">{roles[0]}</div> */}
                  <div className="custom-name-pepper">
                    {name} {surname}
                  </div>
                  <div className="custom-email-pepper">{email}</div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  className="w-100 d-flex justify-content-between custom-logout-pepper"
                  href="/logout"
                >
                  <span className="mr-3 pepper-sign-out">Cerrar sesión</span>
                  <Icon name="sign-out" />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>
  );
};

const Notification = ({
  notificationId,
  title,
  index,
  description,
  comment,
  redirectUrl,
  referenceType,
  ago,
  ok,
  data,
  setOpen,
  isRead,
  uid,
  company,
  currentCompany,
  setNewSelectedCompany,
  clearUrlParams
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { executeMutation: markNotificationAsReadMutation } =
    MarkNotificationAsReaded();

  const goToComment = async () => {
    if (currentCompany != company?.id) {
      await setNewSelectedCompany(company);
    }

    if (!redirectUrl) return;
    setOpen(false);
    dispatch(importOpenSidebar({ show: false }))
    clearUrlParams()

    markNotificationAsReadMutation({
      notificationId: notificationId,
      userId: uid,
      companyId: company?.id
    });
    history.push(redirectUrl);

  };

  return (
    <div
      className={`mainNotificationContainer ${redirectUrl ? 'tw-cursor-pointer' : ''}`}
      key={index}
      onClick={() => goToComment()}
    >
      <div className="mainNotificationContainer__notification">
        <span className="mainNotificationContainer__notification__title tw-flex tw-justify-between tw-items-center">
          <div className="tw-w-[95%]">{title}</div>
          {!isRead && (
            <span
              className={`${ok ? "correctBot" : "required"} tw-text-[#0099FF]`}
            >
              {" "}
              ●{" "}
            </span>
          )}
        </span>
        <span className="mainNotificationContainer__notification__description">
          {description}
        </span>
        {comment && (
          <div className="tw-border-solid tw-border-[1px] tw-border-gray-300 tw-rounded-md tw-p-2 tw-bg-gray-50">
            <span>{comment}</span>
          </div>
        )}
        <span className="mainNotificationContainer__notification__ago">
          {moment(ago, "DD-MM-YYYY h:mm:ss").diff(moment(), "days") > 1
            ? moment(ago, "DD-MM-YYYY h:mm:ss").format("DD-MM-YYYY h:mm:ss")
            : moment(ago, "DD-MM-YYYY h:mm:ss").fromNow()}
        </span>
      </div>
      {/* <div className="mainNotificationContainer__trashContainer">
        <img
          src={iconTrash}
          alt="trash"
          className="mainNotificationContainer__trashContainer__icon tw-cursor-pointer"
        />
      </div> */}
    </div>
  );
};

export default Header;
